import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Angular-Standardverhalten (Route wird bei gleicher Route-Config
 * wiederverwendet), erweitert um ein Opt-in pro Route: Trägt eine Route
 * `data: { rebuildOnParamChange: '<paramName>' }`, wird ihr Komponenten-Teilbaum
 * beim Wechsel dieses Route-Parameters NICHT wiederverwendet, sondern komplett
 * neu aufgebaut (ngOnInit/Guards/Resolver laufen erneut).
 *
 * Genutzt für die Lipp-POS-Route: Beim Wechsel der Station (`:stationId`) über
 * die Sidebar behielt der wiederverwendete Teilbaum sonst Alt-Zustand der
 * Vorstation (Grid-Paging, versions-gegatete Flags wie die Bestellmanager-
 * Einstellungen, ...). Innerhalb derselben Station bleibt alles wiederverwendet.
 */
@Injectable()
export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    // Andere Route-Config → wie im Default nicht wiederverwenden.
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }

    const rebuildParam = future.routeConfig?.data?.['rebuildOnParamChange'] as
      | string
      | undefined;

    if (rebuildParam) {
      // Nur wiederverwenden, solange sich der markierte Parameter nicht ändert.
      return (
        future.paramMap.get(rebuildParam) === curr.paramMap.get(rebuildParam)
      );
    }

    return true;
  }
}
